<app-editor #editor [control]="comment()"
            [createdTags]="ref().tags || []"
            (syncTags)="editorTags.set($event)"
            (addSource)="addSource($event)"
            (uploadCompleted)="uploadCompleted($event)"
            [autoFocus]="true" />
@for (e of serverError(); track e) {
  <span><!-- Unexpected Error --></span>
  <div class="error">{{ e }}</div>
}
<span class="buttons" [class.floating]="editor.showPreview()">
  <button class="comment-save" type="button" [disabled]="editing()" (click)="save()" i18n>save</button>
  @if (editing()) {
    <app-loading [inline]="true" />
  } @else {
    <button class="comment-cancel" type="button" (click)="cancel()" i18n>cancel</button>
  }
</span>
